/**
 * Created by m.igrachev on 7/20/2017.
 */
export default {
    arabic: "ar",
    "arabic-uae": "ar-AE",
    "arabic-bahrain": "ar-BH",
    "arabic-algeria": "ar-DZ",
    "arabic-egypt": "ar-EG",
    "arabic-iraq": "ar-IQ",
    "arabic-jordan": "ar-JO",
    "arabic-kuwait": "ar-KW",
    "arabic-lebanon": "ar-LB",
    "arabic-libya": "ar-LY",
    "arabic-morocco": "ar-MA",
    "arabic-qatar": "ar-QA",
    "arabic-saudi-arabia": "ar-SA",
    "arabic-sudan": "ar-SD",
    "arabic-syria": "ar-SY",
    "arabic-tunisia": "ar-TN",
    "arabic-yemen": "ar-YE",
    czech: "cs-CZ",
    "german ": "de-DE",
    "english-australia": "en-AU",
    "english-uk": "en-GB",
    "english-hong-kong": "en-HK",
    "english-india": "en-IN",
    "english-new-zealand": "en-NZ",
    "english-us": "en-US",
    "english-south-africa": "en-ZA",
    "english-zambia": "en-ZM",
    "spanish ": "es-ES",
    french: "fr-FR",
    "dutch ": "nl-NL",
    polish: "pl-PL",
    portuguese: "pt-PT",
    russian: "ru-RU",
    turkish: "tr-TR"
};
